import DesignFeatureCarousel from '@/atomic-components/carousels/wrappers/design-feature-carousel';
import FlexBox from '@/atomic-components/FlexBox';
import { LencoImage } from '@/atomic-components/Image';
import { DesignFeature } from '@/services/catalogue/models/pdp';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { Box, Grid } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { useState } from 'react';
import RightArrowIconWithColor from '../../../../assets/pdp/rightArrowIconWithMintyColor.svg';
import ProductDesignFeatureGalleryComponent from '../Inclusions/productDesignGallery';

type DesignFeatureComponentProps = {
	designFeatures: DesignFeature[];
	label: string;
};

const DesignFeatureComponent = (props: DesignFeatureComponentProps) => {
	const [openProductGallery, setOpenProductGallery] = useState(false);
	const [galleryIndex, setGalleryIndex] = useState(0);

	const handleProductGallery = (index: number) => {
		setOpenProductGallery(true);
		setGalleryIndex(index);
	};

	return (
		<Grid item md={12}>
			<Box>
				{props.designFeatures && props.designFeatures.length > 0 && (
					<Box sx={{ paddingBottom: '40px' }}>
						<LencoTypography
							sx={{
								...getStyle('H6_Medium'),
								color: getColor('Gray 0'),
								paddingBottom: '24px',
							}}
						>
							{props.label} - Design features
						</LencoTypography>
						{props.designFeatures.length > 1 ? (
							<Box
								id='pdp-design-feature-carousal'
								sx={{
									background: 'transparent',
									'& .swiper-slide': {
										p: '16px 20px',
									},
								}}
							>
								<DesignFeatureCarousel
									spaceBetween={8}
									slidesPerView={2}
									dots={true}
								>
									{props.designFeatures.map((designFeature, index) => {
										return (
											<FlexBox
												key={designFeature.label}
												sx={{
													p: '16px',
													width: 'auto',
													height: '230px',
													background: '#FFFFFF',
													boxShadow: '0px 0px 24px rgba(34, 34, 34, 0.1)',
													borderRadius: '16px',
													padding: '20px',
													alignItems: 'center',
												}}
											>
												<FlexBox>
													<Box
														key={designFeature.label}
														sx={{
															minWidth: '100px',
															height: '100px',
															margin: '12px',
															borderRadius: '50%',
															overflow: 'hidden',
														}}
													>
														<LencoImage
															url={designFeature.thumbnail?.url}
															aspectRatio={designFeature.thumbnail?.aspectRatio}
															alt={'image'}
														/>
													</Box>
												</FlexBox>

												<FlexBox
													direction='column'
													sx={{ alignContent: 'center' }}
												>
													<LencoTypography
														sx={{
															...getStyle('H10_Medium'),
															color: getColor('Gray 0'),
														}}
													>
														{designFeature.label}
													</LencoTypography>
													<LencoTypography
														sx={{
															...getStyle('P_Regular'),
															color: getColor('Gray -2'),
														}}
													>
														{designFeature.description}
													</LencoTypography>

													<FlexBox
														sx={{
															alignItems: 'center',
															cursor: 'pointer',
															'&:hover': {
																'#typo': {
																	...getStyle('P_SemiBold'),
																},
															},
														}}
														onClick={(e) => {
															e.stopPropagation();
															handleProductGallery(index);
														}}
													>
														<LencoTypography
															id='typo'
															sx={{
																...getStyle('P_Medium'),
																color: getColor('Minty +1'),
																paddingRight: '4px',
															}}
														>
															Read more{' '}
														</LencoTypography>
														<Box sx={{ paddingTop: '2px' }}>
															<RightArrowIconWithColor />
														</Box>
													</FlexBox>
												</FlexBox>
											</FlexBox>
										);
									})}
								</DesignFeatureCarousel>
							</Box>
						) : (
							<Box sx={{ paddingLeft: '80px' }}>
								<FlexBox
									sx={{
										width: 'auto',
										height: '230px',
										background: '#FFFFFF',
										boxShadow: '0px 0px 24px rgba(34, 34, 34, 0.1)',
										borderRadius: '16px',
										// border: '1px solid #FFFFFF',
										padding: '20px',
										alignItems: 'center',
									}}
								>
									<FlexBox>
										<Box
											key={props.designFeatures[0].label}
											sx={{
												minWidth: '100px',
												height: '100px',
												margin: '12px',
												borderRadius: '50%',
												overflow: 'hidden',
											}}
										>
											<LencoImage
												url={props.designFeatures[0].thumbnail?.url}
												aspectRatio={
													props.designFeatures[0].thumbnail?.aspectRatio
												}
												alt={'image'}
											/>
										</Box>
									</FlexBox>

									<FlexBox direction='column' sx={{ alignContent: 'center' }}>
										<LencoTypography
											sx={{
												...getStyle('H10_Medium'),
												color: getColor('Gray 0'),
											}}
										>
											{props.designFeatures[0].label}
										</LencoTypography>
										<LencoTypography
											sx={{
												...getStyle('P_Regular'),
												color: getColor('Gray -2'),
											}}
										>
											{props.designFeatures[0].description}
										</LencoTypography>

										<FlexBox
											sx={{
												alignItems: 'center',
												cursor: 'pointer',
												'&:hover': {
													'#typo': {
														...getStyle('P_SemiBold'),
													},
												},
											}}
											onClick={() => {
												handleProductGallery(0);
											}}
										>
											<LencoTypography
												id='typo'
												sx={{
													...getStyle('P_Medium'),
													color: getColor('Minty +1'),
													paddingRight: '4px',
												}}
											>
												Read more{' '}
											</LencoTypography>
											<Box sx={{ paddingTop: '2px' }}>
												<RightArrowIconWithColor />
											</Box>
										</FlexBox>
									</FlexBox>
								</FlexBox>
							</Box>
						)}
					</Box>
				)}
			</Box>
			<ProductDesignFeatureGalleryComponent
				designFeatures={props.designFeatures[galleryIndex]}
				setOpenProductGallery={() => setOpenProductGallery(false)}
				openProductGallery={openProductGallery}
			/>
		</Grid>
	);
};

export default DesignFeatureComponent;
